import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-up-left', 'ArrowUpLeft', [["path",{"d":"M7 7l10 10"}],["path",{"d":"M16 7l-9 0l0 9"}]]);